<template>
	<div class="footFlex">
		<div class="bg-img"></div>
		<div class="content">
			<div class="top">
				<div class="title">工作环境</div>
				<div class="swiper2 swiper-slide">
					<el-carousel v-if="cpArr.length" :interval="1000000000" type="card" height="340px">
						<el-carousel-item v-for="(el, index) in cpArr" :key="index">
							<el-image style="width: 100%; height: 100%" :src="`/04/${el.image}`" fit="cover">
							</el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>

			<div class="bottom">
				<div class="title">招聘职位</div>
				<div class="position-list">
					<div v-for="(el, index) in positionArr" :key="index" @click="positionDetail(el)">
						<div class="list-item">
							<div class="item-left">
								<div class="left-title">{{ el.title }}</div>
								<div class="left-descrption">
									<div>{{ el.site }}</div>
									<div class="split"></div>
									<div>1人</div>
									<div class="split"></div>
									<div>{{ el.ageLimit }}</div>
								</div>
								<div class="left-title">岗位描述</div>
								<div class="left-content">{{ el.describe }}</div>
								<div class="left-detail">查看详情 >></div>
							</div>
							<div class="item-right">申请职位</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer class="foot"></Footer>
	</div>
</template>

<script>
	import Footer from '../../components/footer'
	import { work, position } from '../../api/product'
	import Element from 'element-ui'
	import 'element-ui/lib/theme-chalk/index.css'

	export default {
		name: 'product',
		components: {
			Footer,
		},
		data() {
			return {
				cpArr: [],
				positionArr: [],
				swiperBut: '',
			}
		},
		created() {
			work().then(res => {
				console.log('positionArr : ', res)
				this.cpArr = res.list
				// this.cpArr = this.cpArr.concat(res.list)
			}),
				position().then(res => {
					console.log('cpArr : ', res)
					this.positionArr = res.list
					// this.cpArr = this.cpArr.concat(res.list)
				})
		},
		mounted() {
			this.swipB()
		},
		methods: {
			swipB() {
				var mySwiper2 = new Swiper('.swiper2', {
					slidesPerView: 3,
					observer: true,
					observeParents: true,
					// spaceBetween: 40,
					effect: 'coverflow',
					centeredSlides: true,
					// loop:true,
					pagination: '.swiper-pagination',
					paginationClickable: true,
					uniqueNavElements: false,
					height: 266,
					initialSlide: 1,
					// coverflow: {
					//     rotate: 50,
					//     stretch: 50,
					//     depth: 50,
					//     modifier: 1,
					//     slideShadows : true
					// }
				})
				this.swiperBut = mySwiper2
			},

			positionDetail(el) {
				console.log(el)
				this.$router.push({ path: '/PositionDetail', query: { el } })
			},
		},
	}
</script>

<style scoped lang="less">
	@import '../../assets/css/media.css';
	@Font: 50;
	.footFlex {
		width: 100%;
		min-height: 100%;
		display: flex;
		flex-direction: column;
		.content {
			width: 1280px;
			margin: 100px auto 120px;
			.top {
				.envirment {
					height: 340px;
					.swiper-slide {
						height: 340px;
						display: flex;
						flex-direction: column;
						box-shadow: 1px 1px 5px #eee;
						margin-top: 10px;
						cursor: pointer;
						transition: margin-top 0.5s;
					}
					.swiperImg {
						width: 100%;
						height: 100%;
					}
					.imgbox {
						// flex: 1;
						// overflow: hidden;
						height: 340px;
						flex: none;
					}
					.productImg {
						background-size: auto 100% !important;
						background-position: center !important;
						background-color: #e7e9ed !important;
					}
				}
			}
			.bottom {
				.title {
					margin-top: 100px;
				}
				.position-list {
					display: flex;
					justify-content: space-between;
					flex-wrap: wrap;
					.list-item {
						cursor: pointer;
						margin-bottom: 48px;
						box-sizing: border-box;
						width: 610px;
						height: 233px;
						border: 1px solid #cccccc;
						border-radius: 8px;
						display: flex;
						justify-content: space-between;
						padding: 21px 36px 0;
						.item-left {
							width: 404px;
							.left-title {
								font-size: 18px;
								font-family: PingFang SC;
								font-weight: bold;
								color: #333333;
							}
							.left-descrption {
								margin: 12px 0 20px 0;
								display: flex;
								justify-content: space-between;
								width: 120px;
								font-size: 12px;
								font-family: PingFang SC;
								font-weight: 400;
								color: rgba(17, 17, 17, 0.6);
								height: 12px;
								line-height: 12px;
								.split {
									width: 1px;
									height: 12px;
									background: rgba(17, 17, 17, 0.1);
									opacity: 1;
								}
							}
							.left-content {
								height: 50px;
								font-size: 12px;
								font-family: PingFang SC;
								font-weight: 400;
								line-height: 24px;
								color: #333333;
								overflow: hidden;
								margin: 9px 0 20px 0;
							}
							.left-detail {
								font-size: 12px;
								font-family: PingFang SC;
								font-weight: 400;
								color: #115ddb;
							}
						}
						.item-right {
							font-size: 14px;
							font-family: PingFang SC;
							font-weight: 400;
							line-height: 38px;
							color: #115ddb;
							width: 102px;
							height: 38px;
							border: 1px solid #115ddb;
							box-shadow: 0px 3px 13px rgba(6, 31, 66, 0.42);
							text-align: center;
							margin-top: 6px;
						}
					}
				}
			}
		}
		.list-item:hover .item-right {
			background: #115ddb;
			color: #ffffff !important;
		}
		.list-item:hover {
			box-shadow: 0px 0px 15px rgba(17, 93, 219, 0.15) !important;
		}
		.foot {
			margin-top: auto;
		}
	}
	.title {
		font-size: 26px;
		font-family: PingFang SC;
		font-weight: bold;
		color: rgba(17, 17, 17, 0.85);
		margin-bottom: 56px;
		text-align: center;
	}
	.bg-img {
		height: 380px;
		background: url('../../assets/introduce/组 70.png');
		background-size: cover;
		background-size: 100% 100%;
		margin-top: 76px;
	}

	.el-carouse__item:nth-child(2n) {
		width: 50%;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}

	/* 媒体 */
	@media screen and (max-width: 750px) {
		.bg-img {
			display: block;
			height: 300rem / @Font;
			margin-top: 88rem / @Font;
		}
		.title {
			font-size: 40rem / @Font;
			margin-bottom: 40rem / @Font;
		}
		.footFlex {
			.content {
				width: auto !important;
				margin: 40rem / @Font 30rem / @Font !important;
				padding-bottom: 0;
				.top {
					.swiper2 {
						width: 100%;
					}
				}
				.bottom {
					.title {
						margin-top: 60rem / @Font;
					}
					.position-list {
						flex-direction: column;
						.list-item {
							width: 100%;
							height: auto;
							flex-direction: column;
							padding: 30rem / @Font;
							margin-bottom: 40rem / @Font;
							box-sizing: border-box;
							.item-left {
								width: 100%;
								.left-title {
									font-size: 32rem / @Font;
								}
								.left-descrption {
									width: 100%;
									margin: 20rem / @Font 0;
									font-size: 24rem / @Font;
								}
								.left-content {
									height: auto;
									margin-bottom: 20rem / @Font;
									font-size: 26rem / @Font;
									line-height: 1.6;
								}
								.left-detail {
									font-size: 24rem / @Font;
								}
							}
							.item-right {
								align-self: flex-end;
								margin-top: 20rem / @Font;
							}
						}
					}
				}
			}
		}
		/deep/ .el-carousel__container {
			height: 350rem / @Font !important;
		}
		.el-carousel__item h3 {
			font-size: 14px;
			opacity: 0.75;
			line-height: 340px;
			margin: 0;
		}
	}
</style>
